import { polyfill } from 'es6-promise'; polyfill();
import * as React from 'react';
import { connect } from 'react-redux';
import { CalendarAppState } from '../classes/redux-states';
import { CalendarApiModel } from '../redux/reducers/calendar-api';
import { Dispatch } from 'redux';
import CalendarViewContainer from './calendar-view-container';
import MonthSelectionComponent from './month-selection';
import MonthSelectionJumpComponent from './month-selection-jump';
import CategoryDropdown from './category-filter';
import CalendarToggleComponent from './calendar-toggle';

interface StateToProps {
  noEvents: boolean;
}

interface CalendarContainerState {
  isMobile: boolean;
}

type CalendarContainerProps = StateToProps;

export class CalendarContainer extends React.Component<CalendarContainerProps, CalendarContainerState> {
  constructor(props: CalendarContainerProps) {
    super(props);

    this.state = {
      isMobile: false
    }
  }
  render() {
    return (
      <div className="calendar-wrapper">
        <div className="calendar-filter-container" id="calendar-filter-container">
          <div className="calendar-filter-container-inner">
            <CategoryDropdown />

            {
              !this.state.isMobile ? <CalendarToggleComponent /> : null
            }
          </div>
        </div>

        <MonthSelectionComponent />
        <CalendarViewContainer />
        {
          this.props.noEvents == false ? <MonthSelectionJumpComponent /> : null
        }
        {/* LOADER:
          if requestingEvents = true, mount loader
          else do not mount loader
        */}
      </div>
    )
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({
      isMobile: window.innerWidth <= 768
    });
  }
}

function mapStateToProps(state: CalendarAppState): StateToProps {
  return {
    noEvents: state.calendarApiModel.noEvents
  }
}

export default connect(mapStateToProps, null)(CalendarContainer)



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/calendar-container.tsx